import { render, staticRenderFns } from "./TiendasFormComponent.vue?vue&type=template&id=1243f7c9&"
import script from "./TiendasFormComponent.vue?vue&type=script&lang=js&"
export * from "./TiendasFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports